'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _TetherComponent = require('./TetherComponent');

var _TetherComponent2 = _interopRequireDefault(_TetherComponent);

exports['default'] = _TetherComponent2['default'];
module.exports = exports['default'];


// WEBPACK FOOTER //
// ./~/react-tether/lib/react-tether.js